/* 每章的圖解（列傳選單點一章時顯示），每條列傳一個檔
 * 一章：{
 *   sides: [{ f: 勢力（圖解三國的 FAC 鍵：wei shu wu han hj dz xl ys gs yh lb lbiao lz zl sx jin）, n: '陣營', l: '主要人物', w: 1（勝方才寫） }],
 *   before: '前情：為什麼打這一仗（2～4 句）',
 *   after: '結果與影響（1～3 句）',
 *   src: '主要出處，例如《三國志·魏書·武帝紀》',
 * } */
// @ts-nocheck
import sunwu from './sunwu.ts';
import caocao from './caocao.ts';
import liubei from './liubei.ts';
import guanzhang from './guanzhang.ts';
import zhaoyun from './zhaoyun.ts';
import machao from './machao.ts';
import xiahouyuan from './xiahouyuan.ts';
import simayi from './simayi.ts';
import zhouyu from './zhouyu.ts';
import ganning from './ganning.ts';
import luxun from './luxun.ts';
import taishici from './taishici.ts';

export default Object.assign({}, sunwu, caocao, liubei, guanzhang, zhaoyun, machao, xiahouyuan, simayi, zhouyu, ganning, luxun, taishici);
